import React, { Component } from 'react';
import DocLink from './DocLink.js';

class InstrumentsDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Zequencer comes with a few instruments built-in.
                Click on the instruments tab on the sidebar to view them:
              </p>
              <p className="sub-header">
                Sampled Instrument 
              </p>
              <p>
                A sampler that lets you use several sounds in one sampler, along with refined control
                over looping and ADSR envelopes. Go to <DocLink name="Sampled Instrument" goToLink={this.props.goToLink}/> for more information.
              </p>
              <p className="sub-header">
                Synth
              </p>
              <p>
                A 4 operator, FM-based synthesized.
              </p>
              <p className="sub-header">
                External Instrument
              </p>
              <p>
                A track that can send MIDI to external MIDI devices, such as hardware synths
                or other soft synths on your computer (via MIDI).
              </p>
            </div>
        );
    }
}

export default InstrumentsDocumentation;
